/*
  Build Your Own Bundle.

  ONE UNIT PER DISTINCT PRODUCT. The card button is a toggle, not a stepper: a shopper can take
  several different shampoos but never two of the same one. `picks` is therefore a set keyed by
  variant id with no qty field — the count of picks IS the unit count.

  NO MONEY MATH HERE. The old version computed a discount in the browser and printed
  "you're saving X%" that nothing in the backend enforced, so the page promised a saving the
  checkout never applied.

  The ladder works the other way round now: each tier names a real Shopify discount CODE, and
  after the items are in the cart we hand the shopper to Shopify's own /discount/<code> URL.
  Shopify decides whether it applies and prices the cart. If we pick the wrong tier, Shopify
  refuses the code and the shopper pays full price — the failure direction is always "no
  discount", never "a discount we cannot honour". The only number this file prints is the
  subtotal of what has been picked.
*/
(function () {
  if (window.__bbByobInit) return;
  window.__bbByobInit = true;

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  // "2:10:BUNDLE2, 4:15:BUNDLE4" -> [{qty:4,pct:15,code:'BUNDLE4'}, {qty:2,pct:10,code:'BUNDLE2'}]
  // Sorted richest-first so the first match wins. A row missing any of the three parts is
  // dropped rather than half-applied: a tier with no code could show a percentage the cart
  // would never apply.
  function parseTiers(raw) {
    return (raw || '').split(',').map(function (row) {
      var p = row.trim().split(':');
      return { qty: parseInt(p[0], 10), pct: parseFloat(p[1]), code: (p[2] || '').trim() };
    }).filter(function (t) {
      return t.qty > 0 && t.pct > 0 && t.code;
    }).sort(function (a, b) { return b.qty - a.qty; });
  }

  // Shopify FLOORS a percentage discount on EACH LINE to the cent, then sums the lines. It does
  // not take the percentage off the cart total. The difference is real money on screen:
  //   5 items, $153.97 at 20%  ->  per-line floored $30.77   (cart-total rounded gives $30.79)
  //   4 items, $123.98 at 15%  ->  per-line floored $18.58   (cart-total rounded gives $18.60)
  // Both per-line figures were read back out of a live cart. Match Shopify exactly or the Total
  // printed here is two cents away from what the customer is charged, which is the same class of
  // bug this page was rebuilt to kill — just quieter.
  function discountCents(prices, pct) {
    var d = 0;
    for (var i = 0; i < prices.length; i++) d += Math.floor(prices[i] * pct / 100);
    return d;
  }

  function initByob(root) {
    var cfg = {
      max: parseInt(root.getAttribute('data-max'), 10) || 6,
      min: parseInt(root.getAttribute('data-min'), 10) || 2,
      freeship: parseFloat(root.getAttribute('data-freeship')) || 50,
      tiers: parseTiers(root.getAttribute('data-tiers'))
    };

    // richest tier the given unit count has earned, or null
    function tierFor(units) {
      for (var i = 0; i < cfg.tiers.length; i++) if (units >= cfg.tiers[i].qty) return cfg.tiers[i];
      return null;
    }
    // cheapest tier not yet reached, for the "add one more" nudge
    function nextTier(units) {
      var best = null;
      for (var i = 0; i < cfg.tiers.length; i++) {
        if (cfg.tiers[i].qty > units && (!best || cfg.tiers[i].qty < best.qty)) best = cfg.tiers[i];
      }
      return best;
    }

    var countEl = root.querySelector('[data-byob-count]');
    var fillEl = root.querySelector('[data-byob-progress-fill]');
    var chosenEl = root.querySelector('[data-byob-chosen]');
    var totalsEl = root.querySelector('[data-byob-totals]');
    var subEl = root.querySelector('[data-byob-subtotal]');
    var discRowEl = root.querySelector('[data-byob-discountrow]');
    var discLabelEl = root.querySelector('[data-byob-discountlabel]');
    var discEl = root.querySelector('[data-byob-discount]');
    var totalEl = root.querySelector('[data-byob-total]');
    var shipEl = root.querySelector('[data-byob-ship]');
    var ctaEl = root.querySelector('[data-byob-cta]');
    var hintEl = root.querySelector('[data-byob-hint]');
    var tierEls = [].slice.call(root.querySelectorAll('[data-byob-tiers] [data-tier-qty]'));

    // variantId -> { price, title, img, station, stationLabel, btn }
    var picks = Object.create(null);
    var order = []; // insertion order, so the rail lists picks in the order they were chosen

    function unitCount() { return order.length; }
    function subtotalCents() {
      var c = 0;
      for (var i = 0; i < order.length; i++) c += picks[order[i]].price;
      return c;
    }

    function syncCard(id) {
      var it = picks[id];
      var btn = it ? it.btn : root.querySelector('[data-byob-add][data-vid="' + id + '"]');
      if (!btn) return;
      var card = btn.closest('.shop-card');
      if (!card) return;
      var inBundle = !!it;
      card.classList.toggle('is-in', inBundle);
      btn.setAttribute('aria-pressed', inBundle ? 'true' : 'false');
      btn.textContent = inBundle ? 'In your bundle' : (btn.getAttribute('data-label-add') || 'Add to Bundle');
      var badge = card.querySelector('[data-byob-badge]');
      if (badge) badge.hidden = !inBundle;
    }

    // Station chips in the banner and the per-station counters both read the same tally.
    function renderStations() {
      var tally = Object.create(null);
      for (var i = 0; i < order.length; i++) {
        var st = picks[order[i]].station;
        tally[st] = (tally[st] || 0) + 1;
      }
      root.querySelectorAll('[data-byob-mapitem]').forEach(function (link) {
        // the filled class drives the node fill AND the dashed-to-solid connector, both of
        // which hang off the <li>, so mark the step rather than the anchor
        var step = link.closest('.byob__pathstep') || link;
        step.classList.toggle('is-filled', !!tally[link.getAttribute('data-byob-mapitem')]);
      });
      root.querySelectorAll('[data-byob-stationcount]').forEach(function (el) {
        var n = tally[el.getAttribute('data-byob-stationcount')] || 0;
        el.hidden = n === 0;
        el.textContent = n === 1 ? '1 added' : n + ' added';
      });
    }

    function render() {
      var units = unitCount();
      var sub = subtotalCents();

      countEl.textContent = units;
      fillEl.style.transform = 'scaleX(' + Math.min(1, units / cfg.max) + ')';

      if (!units) {
        chosenEl.innerHTML = '<li class="byob__empty" data-byob-empty>Start building your bundle</li>';
        totalsEl.hidden = true;
      } else {
        chosenEl.innerHTML = '';
        var lastStation = null;
        order.forEach(function (id) {
          var it = picks[id];
          if (it.station !== lastStation) {
            lastStation = it.station;
            var head = document.createElement('li');
            head.className = 'byob__cgroup';
            head.textContent = it.stationLabel;
            chosenEl.appendChild(head);
          }
          var li = document.createElement('li');
          li.className = 'byob__ci';
          // textContent everywhere — product titles are merchant data, never trusted as markup.
          var img = null;
          if (it.img) {
            img = document.createElement('img');
            img.src = it.img;
            img.alt = '';
            li.appendChild(img);
          }
          var main = document.createElement('span');
          main.className = 'byob__ci-main';
          var t = document.createElement('span');
          t.className = 'byob__ci-t';
          t.textContent = it.title;
          var p = document.createElement('span');
          p.className = 'byob__ci-p';
          p.textContent = money(it.price);
          main.appendChild(t);
          main.appendChild(p);
          li.appendChild(main);

          var x = document.createElement('button');
          x.type = 'button';
          x.className = 'byob__ci-x';
          x.setAttribute('data-remove', id);
          x.setAttribute('aria-label', 'Remove ' + it.title);
          x.textContent = '×';
          li.appendChild(x);

          chosenEl.appendChild(li);
        });
        totalsEl.hidden = false;
      }

      var tier = tierFor(units);
      var next = nextTier(units);

      // Every figure in the rail comes off this one calculation, so the Total, the free-shipping
      // test and the checkout button can never disagree with each other.
      var prices = order.map(function (id) { return picks[id].price; });
      var disc = tier ? discountCents(prices, tier.pct) : 0;
      var total = sub - disc;

      subEl.textContent = money(sub);
      discRowEl.hidden = !tier;
      if (tier) {
        discLabelEl.textContent = 'Discount (' + tier.pct + '%)';
        discEl.textContent = '−' + money(disc);
      }
      totalEl.textContent = money(total);

      tierEls.forEach(function (el) {
        var q = parseInt(el.getAttribute('data-tier-qty'), 10);
        el.classList.toggle('is-hit', units >= q);
        el.classList.toggle('is-next', !!next && q === next.qty);
      });

      // Free shipping is a price-based rate, so Shopify reads the subtotal AFTER the code comes
      // off. Testing the undiscounted subtotal here would promise free shipping to a $52 cart
      // that a 20% code drops to $41.60. Test the real Total instead: if Shopify ends up refusing
      // the code the shopper gets free shipping anyway, which is the safe way to be wrong.
      var shipDollars = total / 100;
      if (shipDollars >= cfg.freeship) {
        shipEl.textContent = '✓ You’ve unlocked free US shipping.';
        shipEl.className = 'byob__ship is-free';
      } else {
        shipEl.textContent = 'Add ' + money((cfg.freeship - shipDollars) * 100) + ' more for free US shipping.';
        shipEl.className = 'byob__ship';
      }

      if (units < cfg.min) {
        ctaEl.disabled = true;
        ctaEl.textContent = 'Add ' + cfg.min + '+ items to start';
      } else {
        ctaEl.disabled = false;
        // The amount on the button is what they will actually pay, not the subtotal.
        ctaEl.textContent = 'Checkout · ' + money(total);
      }

      // hintEl doubles as the error line, so the nudge gets its own class — the default hint
      // colour is the error red and an upsell must not read as a failure.
      if (units >= cfg.max) {
        hintEl.textContent = 'Bundle is full (' + cfg.max + ' items max).';
        hintEl.className = 'byob__hint';
      } else if (next && units >= 1) {
        var need = next.qty - units;
        hintEl.textContent = 'Add ' + need + ' more for ' + next.pct + '% off.';
        hintEl.className = 'byob__hint is-nudge';
      } else {
        hintEl.textContent = '';
        hintEl.className = 'byob__hint';
      }
      renderStations();
    }

    function remove(id) {
      if (!picks[id]) return;
      delete picks[id];
      var i = order.indexOf(id);
      if (i > -1) order.splice(i, 1);
      syncCard(id);
      render();
    }

    function add(id, meta) {
      if (picks[id]) return;
      if (order.length >= cfg.max) {
        hintEl.textContent = 'Bundle is full (' + cfg.max + ' items max). Remove something to swap it out.';
        return;
      }
      picks[id] = meta;
      order.push(id);
      syncCard(id);
      render();
    }

    // Phone: the step path is a scrolling rail, so step 5 starts off-screen. The banner carries
    // a right-edge fade to say so (CSS, phone only); clear it once the shopper reaches the end,
    // or the fade would sit on top of the very label it exists to advertise. Also cleared when
    // the rail is not scrollable at all, which is every desktop width.
    var pathNav = root.querySelector('.byob__path');
    var pathList = root.querySelector('.byob__pathlist');
    if (pathNav && pathList) {
      var syncPathFade = function () {
        var scrollable = pathList.scrollWidth > pathList.clientWidth + 2;
        var atEnd = pathList.scrollLeft + pathList.clientWidth >= pathList.scrollWidth - 2;
        pathNav.classList.toggle('is-scrollend', !scrollable || atEnd);
      };
      pathList.addEventListener('scroll', syncPathFade, { passive: true });
      window.addEventListener('resize', syncPathFade);
      syncPathFade();
    }

    // Phone floating CTA: a dumb mirror of the rail button. ONE source of truth — the rail
    // CTA — so the bar can never disagree with it: a MutationObserver copies its text and
    // disabled state (including the 'Adding…' in-flight state the checkout handler sets), and
    // clicks forward to the real handler. The bar hides while the real CTA is on screen, so
    // the shopper never sees the same button twice.
    var stickyEl = root.querySelector('[data-byob-sticky]');
    var stickyBtn = root.querySelector('[data-byob-sticky-cta]');
    if (stickyEl && stickyBtn) {
      var syncSticky = function () {
        stickyBtn.textContent = ctaEl.textContent;
        stickyBtn.disabled = ctaEl.disabled;
      };
      new MutationObserver(syncSticky)
        .observe(ctaEl, { childList: true, attributes: true, attributeFilter: ['disabled'] });
      syncSticky();
      stickyBtn.addEventListener('click', function () { ctaEl.click(); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          stickyEl.classList.toggle('is-off', entries[0].isIntersecting);
        }).observe(ctaEl);
      }
    }

    // Card toggle. Delegated from the section root so every station is covered by one listener.
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-byob-add]');
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      var id = btn.getAttribute('data-vid');
      if (picks[id]) { remove(id); return; }
      var station = btn.closest('[data-byob-station]');
      add(id, {
        price: parseInt(btn.getAttribute('data-price'), 10) || 0,
        title: btn.getAttribute('data-title') || '',
        img: btn.getAttribute('data-img') || '',
        station: station ? station.getAttribute('data-byob-station') : '',
        stationLabel: station ? (station.querySelector('.byob__h2') || {}).textContent || '' : '',
        btn: btn
      });
    });

    // Rail remove.
    chosenEl.addEventListener('click', function (e) {
      var t = e.target.closest('[data-remove]');
      if (!t) return;
      remove(t.getAttribute('data-remove'));
    });

    // Add to cart. Quantity is always 1 per line — that is the whole rule.
    ctaEl.addEventListener('click', function () {
      if (ctaEl.disabled) return;
      var items = order.map(function (id) {
        return { id: Number(id), quantity: 1, properties: { _byob: '1' } };
      });
      if (!items.length) return;
      ctaEl.disabled = true;
      var orig = ctaEl.textContent;
      ctaEl.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          // Hand the earned tier to Shopify rather than pricing it here. /discount/<code> is
          // Shopify's own endpoint: it stores the code on the session and forwards to `redirect`.
          // Shopify then decides whether the minimum quantity is met. No tier earned (or the
          // ladder is switched off) -> straight to the cart, no code, nothing promised.
          //
          // DELIBERATE: the tier comes from THIS bundle's size, not the whole cart, even though
          // the code's minimum counts every qualifying item in the cart. Do not "fix" this by
          // reading /cart.js for a total — the cart can hold items outside the discount's
          // collection, so a cart-wide count can OVERSHOOT the qualifying quantity and Shopify
          // then refuses the code outright, leaving the shopper with nothing. Undershooting
          // costs a shopper who already had items in their cart one rung of the ladder; the
          // discount still applies. Wrong-but-applies beats right-but-refused.
          // Straight to checkout, not the cart. /discount/<code> stores the code on the session
          // and forwards to `redirect`, so the discount is already on the order the moment the
          // checkout renders. With no tier earned there is no code to apply, so go direct.
          var tier = tierFor(items.length);
          window.location.href = tier
            ? '/discount/' + encodeURIComponent(tier.code) + '?redirect=' + encodeURIComponent('/checkout')
            : '/checkout';
        })
        .catch(function () {
          ctaEl.disabled = false;
          ctaEl.textContent = orig;
          hintEl.textContent = 'We could not add that to your bag. Please try again.';
          hintEl.className = 'byob__hint';
        });
    });

    render();
  }

  function boot() { document.querySelectorAll('[data-byob]').forEach(initByob); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
